import React from "react";
import { Box, Grid, makeStyles, Paper } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import AppColor from "utilities/AppColor";
import PropTypes from "prop-types";
import AppButton from "components/CustomButtons/AppButton";

const styles = makeStyles(() => ({
  marginVertical: {
    marginTop: '100px',
    marginBottom: '100px'
  },
  success: {
    fontSize: '7rem',
    color: AppColor.mainColor,
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3rem',
    '& .title-success': {
      fontSize: '1rem',
      color: AppColor.black,
      marginTop: '2rem'
    },
    '& .message-success': {
      color: AppColor.black,
      fontSize: '0.8rem',
      marginTop: '0rem'
    }
  }
}));

const SuccessPage = (props) => {
  const {
    titleSuccess,
    messageSuccess,
    onConfirm,
    labelButton
  } = props;
  const { t } = useTranslation();
  const classes = styles();

  return (
    <Box className={`container-fluid ${classes.marginVertical}`}>
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={6} md={4}>
          <Paper className={classes.success}>
            <i className="far fa-check-circle"></i>
            <span className='title-success'>{t(titleSuccess)}</span>
            <span className='message-success'>{t(messageSuccess)}</span>
            <Box display="flex" justifyContent="flex-end" className="mt-5">
              <AppButton
                onClick={onConfirm}
                label={t(labelButton)}
              />
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box >
  );
}

SuccessPage.propTypes = {
  titleSuccess: PropTypes.string,
  messageSuccess: PropTypes.string,
  labelButton: PropTypes.string,
  onConfirm: PropTypes.func
};

export default SuccessPage;
